import camelCase from 'lodash.camelcase';
import snakeCase from 'lodash.snakecase';
import { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { config } from '../../../utils/config';
import { ValidationResult } from '../../../utils/getValidator';
import { pushTrackingEvent } from '../../../utils/tracking';
import { useFormName } from '../../../utils/formName';
import './style.scss';

const ErrorMessage = ({ label, error, dataTestId }: { label: string; error: ValidationResult; dataTestId: string }) => {
  const { formName } = useFormName();
  const { sendFormFieldErrors } = config.tracking;

  useEffect(() => {
    if (error && sendFormFieldErrors) {
      pushTrackingEvent({
        event: 'error',
        action: snakeCase(formName),
        label: camelCase(label),
        value: error.key
      });
    }
  }, [error, formName]);

  if (!error) {
    return null;
  }

  return (
    <div className="input-error-message" data-test-id={`${dataTestId}-error-message`}>
      <FormattedMessage
        id={error.skipErrorPrefix ? error.key : `errors.${error.key}`}
        values={{ label, ...error.values }}
      />
    </div>
  );
};

export default ErrorMessage;
